---
nb:
  power_plants:
    asset_class_types:
      all: ALL
      bilateral/asset: Bilateral
      hydro/asset: Vann
      solar/asset: Sol
      wind/asset: Vind
    bell:
      link_ok: Linken er OK
      no_link: Ingen lenke
    bilateral_capacity_hint: Installert kapasitet for dette bilaterale kraftverket
    capacity_hint: Endres ved å redigere produserende komponent
    change_selection: Endre kraftverksutvalg
    chart_load:
      categories:
      - Ingen produksjon
      - L (25%)
      - M (25% - 75%)
      - H (> 75%)
      last_month: Forrige måned
      subtitle: "% av tiden, time for time"
      this_month: Denne måned
      title: Last
    chart_meteogram_title: 48-timersvarsel
    commercial_details: Kommersielle detaljer
    commissioning_date_hint: Første driftsdag
    deviation: Avvik
    edit_heading: Rediger kraftverksinformasjon
    edit_notice: Kontakt Kaia hvis begrensede felt skal endres
    effect_hint: Endres ved å redigere produserende komponent
    elcert_count: Ant. sertifikater
    environmental_flow_breakpoints: Minstevannføring
    errors:
      different_source: Må være forskjellig fra den avregnende volumkilden
      missing_attribute: Manglende %{attribute}
      shadow_excludes_unscaled_contract: kan ikke aktiveres mens en innmatingstariff- eller sikringskontrakt er knyttet til, siden disse kontraktene ikke har en eierandel til å fordele delt produksjon
      shadow_requires_canonical: må samsvare med målepunktet til et eksisterende ikke-skygge-kraftverk
    est_downtime_cost: Est. nedetidskostnad
    est_production: Est. produksjon
    est_tech_downtime: Est. teknisk nedetid
    export_xlsx: Eksporter til Excel
    financial_settlement: Finansielt oppgjør
    generator: Generator
    go_count: Antall
    intake: Inntak
    intakes: Inntak
    kpi_monthly: Månedlig ytelse
    measure_theor_production: Oversikt - faktisk mot prognostisert produksjon
    measured_power: Målt effekt
    model_params:
      empty: Ingen modellparametere tilgjengelig.
      nve_fallback_hint: Bruker NVE-verdi (overstyr ved å skrive inn en verdi)
      production_min_runtime_hours_hint: Brukes bare av deterministic_2step. Tom = API-standarden på 24 t. Må passe innenfor optimeringshorisonten (perioder × segmenter, 168 t som standard), ellers blir minimumet aldri startet fra stillstand.
      startup_override_placeholder: Skriv inn produksjonsverdier
    monthly_production: Månedlig oversikt - faktisk mot prognostisert produksjon
    nve_info: NVE info
    of_ytd_avg: av gjennomsnitt så langt i år
    of_ytd_budget: av budsjett så langt i år
    penstock: Rørgate
    power_curve: Kraftkurve
    power_plant_age: Kraftverksalder
    precipitation_field: Nedbørsfelt
    price_prod_history: Pris- og produksjonshistorikk
    prod_bud_by_month: Produksjon / Budsjett per måned
    prod_by_month: Produksjon per måned
    prod_sales_data: Produksjon- og salgsdata
    reservoir: Magasin
    rev_bud_by_month: Inntekt / Budsjett per måned
    rev_by_month: Inntekt per måned
    river: Elv
    runoff_avg: Gj. avrenning
    runoff_ytd: Avrenning i år
    select_day: Velg dag i måneden
    select_month: Velg måned
    shadow_source_hint: Kopierer målepunkt-ID-en til det valgte anlegget inn i feltet over
    shadow_source_label: Kopier målepunkt fra anlegg
    solar_inverter_production: Normalisert daglig produksjon fra likeretter [kWh/kWp]
    solar_kpi_epi: Energy Performance Index
    solar_kpi_pr: Performance Ratio
    solar_kpi_system_losses: Systemtap
    spider_categories:
    - Fullasttimer (%)
    - Oppnådd pris vs spotpris
    - Driftstimer totalt
    - Driftstimer natt
    - Teoretisk produksjon vs normalproduksjon
    - Avrenning vs normal
    spot_price: Spotpris
    spot_revenue: Spotomsetning
    starts_stops: Start/stopp
    substation: Transformatorstasjon
    supplier_add: Legg til leverandør
    supplier_form_title: Utstyrsleverandører
    theoretical_power: Teoretisk effekt
    tooltips:
      continuous_forecast_enabled: Sender day-ahead produksjonsprognose på nytt når nye værdata fra Meteomatics kommer inn (vind-/solverk).<br>Krever Forecast query og Day-ahead forecast.
      day_ahead_forecast_enabled: Sender day-ahead produksjonsprognose (15-minutters oppløsning) til Kaia Trade for vind-/solverk hver time kl. 07:20–11:20.<br>Krever Forecast query.
      forecast_query_enabled: Hovedbryter for utgående innsendinger til Kaia Trade.<br>Når aktivert sender den timesvise jobben kl. 07:20–11:20 (og den kontinuerlige værpolleren) det bryterne nedenfor aktiverer&#58; produksjonsplaner, day-ahead prognoser og prisavhengige bud.<br>Deaktivering stopper alle innsendinger for dette kraftverket.
      production_simulation_plan_enabled: Kjører produksjonssimuleringen lokalt hver time fra kl. 07:10 til 11:10 og lagrer den resulterende planen.<br>Planen sendes deretter til Kaia Trade av den tilhørende jobben kl. 07:20–11:20 — den innsendingen krever også Forecast query, en Kaia UUID og at Skyggetesting er av.<br>Returnerte godkjent/avvist-statuser lagres på hvert planelement.
      shadow_testing: Skyggetesting — spør produksjonsplanleggings-API-et, men sender ingenting til Trade (Kaia).<br>Bruk dette for å teste produksjonsplanlegging uten å påvirke markedsinnsendinger.
      use_price_dependent_bid: Sender en prisavhengig budkurve til Kaia Trade hver time kl. 07:20–11:20, basert på markedspriser og kraftverksøkonomi.<br>Krever Forecast query og en Market parameter med budgivning aktivert på dette kraftverket.
    tot_power_rev: Tot. kraftomsetning
    total_hours: Timer totalt
    total_revenue: Omsetning totalt
    total_sales: Salg totalt
    transformer: Transformator
    turbine: Turbin
    turbine_types:
      bulb: Bulb
      francis: Francis
      kaplan: Kaplan
      lawaczeck: Lawaczeck
      ossberger: Ossberger
      pelton: Pelton
      pump: Pump
      turgo: Turgo
    unconfirmed: Anslåtte / ubekreftede tall
    water_icon:
      alert: Varsel om vannstand
      normal: Normal vannstand
      overflow: Flyte
      underflow: Underløp
      update: Ingen nyere data
    wind_kpi_eb_availability: Energibasert tilgjengelighet
    wind_kpi_eb_losses: Energitap
    wind_rose: Vindrose
